import Phaser from 'phaser';
import { PALETTE } from '../config';
import { onResize } from './viewport';

/**
 * Full-screen vertical gradient backdrop. A tall 1px-wide gradient texture is generated
 * once and stretched to the viewport, re-fitting on resize. Cheap stand-in for art.
 */
export function drawGradientBackground(
  scene: Phaser.Scene,
  top: number = PALETTE.bgTop,
  bottom: number = PALETTE.bgBottom,
): Phaser.GameObjects.Image {
  const key = `bg:${top.toString(16)}:${bottom.toString(16)}`;
  const H = 512;
  if (!scene.textures.exists(key)) {
    const g = scene.make.graphics({ x: 0, y: 0 });
    const c1 = Phaser.Display.Color.IntegerToColor(top);
    const c2 = Phaser.Display.Color.IntegerToColor(bottom);
    for (let i = 0; i < H; i++) {
      const c = Phaser.Display.Color.Interpolate.ColorWithColor(c1, c2, 100, (i / (H - 1)) * 100);
      g.fillStyle(Phaser.Display.Color.GetColor(c.r, c.g, c.b), 1);
      g.fillRect(0, i, 4, 1);
    }
    g.generateTexture(key, 4, H);
    g.destroy();
  }
  const img = scene.add.image(0, 0, key).setOrigin(0, 0).setScrollFactor(0).setDepth(-100);
  const fit = () => img.setDisplaySize(scene.scale.width, scene.scale.height);
  fit();
  onResize(scene, fit);
  return img;
}
